import styled from 'styled-components';
import { COLORS } from './../../../../ui';

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
`;

Wrapper.display = 'Wrapper';

export const WeekDay = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex: 1 1 0;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: ${COLORS.BLACK};
  font-weight: bold;
`;

WeekDay.displayName = 'WeekDay';
